export default "__VITE_ASSET__26db3f90__"